if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.cartNoti = document.querySelector("cart-notification");
        this.cartDrawer = document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        /*         console.log("Drawer Event Started"); */
        /*         console.log(this.submitButton); */
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        /*     this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        ); */

        const configNoti = fetchConfig("javascript");
        configNoti.headers["X-Requested-With"] = "XMLHttpRequest";
        delete configNoti.headers["Content-Type"];

        const configDrawer = fetchConfig("javascript");
        configDrawer.headers["X-Requested-With"] = "XMLHttpRequest";
        delete configDrawer.headers["Content-Type"];

        const formDataNoti = new FormData(this.form);
        const formDataDrawer = new FormData(this.form);
        if (this.cartNoti) {
          formDataNoti.append(
            "sections",
            this.cartNoti.getSectionsToRenderNoti().map((section) => section.id)
          );
          formDataNoti.append("sections_url", window.location.pathname);
          this.cartNoti.setActiveElementCartNoti(document.activeElement);
        }
        if (this.cartDrawer) {
          formDataDrawer.append(
            "sections",
            this.cartDrawer.getSectionsToRender().map((section) => section.id)
          );
          formDataDrawer.append("sections_url", window.location.pathname);
          this.cartDrawer.setActiveElement(document.activeElement);
        }
        configNoti.body = formDataNoti;
        configDrawer.body = formDataDrawer;

        fetch(`${routes.cart_add_url}`, configNoti)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formDataNoti.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formDataNoti.get("id"),
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cartNoti.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cartNoti.renderContents(response);
            }

            // Coloca el código aquí para desactivar el botón en el cart-drawer si es necesario
            var trueFound = false;
            var falseFound = false;

            if (trueFound && falseFound) {
              var button = document.getElementById("CartDrawer-Checkout");
              button.setAttribute("disabled", "disabled");
              var popup = document.getElementById("drawer-popup");
              popup.style.display = "block";
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cartNoti && this.cartNoti.classList.contains("is-empty"))
              this.cartNoti.classList.remove("is-empty");
            if (this.cartDrawer && this.cartDrawer.classList.contains("is-empty"))
              this.cartDrawer.classList.remove("is-empty");

            // Call the function to get the most expensive product's id
            let mostExpensiveId = getMostExpensiveProductId();

            if (typeof mostExpensiveId == "string") {
              getProductRelated("gid://shopify/Product/" + mostExpensiveId);
            }

            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });

        fetch(`${routes.cart_add_url}`, configDrawer)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formDataDrawer.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formDataDrawer.get("id"),
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cartDrawer.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cartDrawer.renderContents(response);
            }

            // Coloca el código aquí para desactivar el botón en el cart-drawer si es necesario
            var trueFound = false;
            var falseFound = false;
            var cartItems = document.querySelectorAll(".cart-item");

            cartItems.forEach(function (item) {
              var teamStoreValue = item.getAttribute("data-team-store-drawer");
              if (teamStoreValue === "true") {
                trueFound = true;
              } else if (teamStoreValue === "false") {
                falseFound = true;
              }
            });

            if (trueFound && falseFound) {
              var button = document.getElementById("CartDrawer-Checkout");
              button.setAttribute("disabled", "disabled");
              var popup = document.getElementById("drawer-popup");
              popup.style.display = "block";
            }
              new Swiper('#product-slider-cart-drawer', {
                navigation: {
                  nextEl: '.section-recommend-swiper-button-next',
                  prevEl: '.section-recommend-swiper-button-prev',
                },
                slidesPerView: 2,
                spaceBetween: 4,
                breakpoints: {
                  551: {
                      slidesPerView: 2,
                      spaceBetween: 4,
                  },
                  750: {
                    slidesPerView: 2,
                    spaceBetween: 4,
                  },
                  1024: {
                    slidesPerView: 2,
                    spaceBetween: 4,
                  }
                }
              });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cartNoti && this.cartNoti.classList.contains("is-empty"))
              this.cartNoti.classList.remove("is-empty");
            if (this.cartDrawer && this.cartDrawer.classList.contains("is-empty"))
              this.cartDrawer.classList.remove("is-empty");

            // Call the function to get the most expensive product's id
            let mostExpensiveId = getMostExpensiveProductId();

            if (typeof mostExpensiveId == "string") {
              getProductRelated("gid://shopify/Product/" + mostExpensiveId);
            }

            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
